/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Progress, Loader, toaster } from 'rsuite';
import { cuotitasStoreService } from '../../../services';
import { checkPersonStep } from './createLoanSteps/checkPersonStep';
import { ModifyPersonStep } from './createLoanSteps/modifyPersonStep';
import installmentsStep from './createLoanSteps/installmentsStep';
import { tradePoliciesStep } from './createLoanSteps/tradePoliciesStep';
import { DigitalSignStep } from './createLoanSteps';
import CreatePersonStep from './createLoanSteps/createPersonStep';
import RepeatPersonsStep from './createLoanSteps/repeatPersonsStep';
import { isInteger } from 'lodash';
import { getSessionUserByStorage, getStoreByStorage, removeStorage, setStorage, sortAlphabetically } from '../../../helpers';
import { getTemplate } from '../../../components/templates/Email';
import { getDataError } from '../../../helpers/ErrorMappers';
import { updateFile } from '../../../helpers/Fs';
import ENABLE from '../../../constants/enable';
import ShortUniqueId from 'short-unique-id';
import useTheme from '../../../hooks/useTheme';

const localities = require('../../../constants/loans/localities.json');

const activities = [];
const activitiesResponse = [
    {
        id: 1,
        description: 'MONOTRIBUTISTA'
    },
    {
        id: 2,
        description: 'EMPLEADO PRIVADO'
    },
    {
        id: 3,
        description: 'AUTONOMO'
    },
    {
        id: 4,
        description: 'JUBILADO/PENSIONADO'
    },
    {
        id: 5,
        description: 'SERVICIO DOMESTICO'
    },
    {
        id: 6,
        description: 'JUBILADOS CAJA 40'
    },
    {
        id: 7,
        description: 'PERSONAL UNIFORMADO'
    },
    {
        id: 8,
        description: 'CONTRATADO PRIVADO'
    },
    {
        id: 10,
        description: 'EMPLEADO PUBLICO NACIONAL O CIUDAD DE BS AS'
    },
    {
        id: 12,
        description: 'EMPLEADO PUBLICO PROVINCIAL O MUNICIPAL'
    },
    {
        id: 13,
        description: 'AUH'
    },
    {
        id: 14,
        description: 'CUENTA PROPISTA'
    },
    {
        id: 15,
        description: 'AMA DE CASA'
    },
    {
        id: 16,
        description: 'ESTUDIANTE'
    }
];

const initialStep = 1;
const maxSteps = 5;
const defaultCheckUser = {
    firstName: '',
    lastName: '',
    document: '',
    gender: '',
    telephone: ''
};

const defaultMainUser = {
    firstName: '',
    lastName: '',
    document: '',
    gender: '',
    bornDate: undefined,
    email: '',
    telephone: '',
    cellPhoneAreaCode: '',
    cellPhoneCharacteristic: '',
    cellPhoneNumber: '',
    additionalPhoneAreaCode: '',
    additionalPhoneCharacteristic: '',
    additionalPhoneNumber: '',
    activity: '',
    amount: '',
    validateTelephone: '',
    province: '',
    department: '',
    location: '',
    postcode: '',
    street: '',
    number: '',
    floor: '',
    apartment: '',
    'reference-firstName': '',
    'reference-lastName': '',
    'reference-relation': '',
    'reference-isCellPhone': '',
    'reference-phoneAreaCode': '',
    'reference-phoneCharacteristic': '',
    'reference-phoneNumber': ''
};

const defaultInstallmentsExtraData = {
    idsPlan: '',
    assistanceMapping: '',
    commercialPlans: ''
};

const defaultInstallments = {
    amount: '', // cantidad para prestar
    installments: '', // Cuotas
    installmentCoefficient: '', // coeficiente multiplicador
};
const defaultAmountLimit = {
    amountMin: 1,
    amountMax: 1,
};

const defaultPoliticies = [{
    id: 1,
    label: '',
    value: {
        idCommercePolicy: 1,
        idArticle: 1
    }
}];

const defaultNotification = {
    code: 200,
    message: 'Ok',
    notification: {
        id: 1,
        id_notification_status: 1,
        sms_status: 'delivered',
    }
};

const getDepartmentByLocation = (idLocality) => {
    if (idLocality) {
        const location = localities.find(location => location?.id === idLocality);
        return location?.idPartido;
    }
    return '';
};

const parseDate = (value) => {
    const date = value?.split('/');
    if (value && date?.length === 3) {
        return new Date(`${date[1]}/${date[0]}/${date[2]}`);
    }
    return undefined;
};

export default function CreateNewLoan ({ show, onHide }) {
    const theme = useTheme();

    //
    // Session data
    //
    const sessionUser = getSessionUserByStorage();
    const store = getStoreByStorage();
    const idStore = store?.id;

    // Form values states
    const [copy, setCopy] = useState({
        value: '',
        copied: false,
    });
    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    const [isAllowContinue, setIsAllowContinue] = useState(true);
    const [isAllowBack, setIsAllowBack] = useState(true);
    // Steps
    const [step, setStep] = useState(initialStep);
    const [politicies, setPoliticies] = useState(defaultPoliticies);
    const [installment, setInstallment] = useState(defaultInstallments); // TODO revisar defaultInstallments
    const [installmentsExtraData, setInstallmentsExtraData] = useState(defaultInstallmentsExtraData);
    const [amountLimit, setAmountLimit] = useState(defaultAmountLimit);
    // Data from steps
    const [sign, setSign] = useState();
    const [request, setRequest] = useState();
    const [offer, setOffer] = useState();
    // sms
    // TODO check if buttonSmsClicked in used
    const [buttonSmsClicked, setButtonSmsClicked] = useState(false);
    const [notification, setNotification] = useState(defaultNotification);
    // needed for audit
    const [uniqueTraceId, setUniqueTraceId] = useState();

    /**
     * Estados de los formularios
     */
    // Get person modal
    const formRef = React.useRef();
    const [formErrorCheckUser, setFormErrorCheckUser] = React.useState({});
    const [formCheckUser, setFormCheckUser] = React.useState(defaultCheckUser);
    const [repeatUsers, setRepeatUsers] = React.useState([]);

    // form person details modal
    const [formErrorMainUser, setFormErrorMainUser] = React.useState({});
    const [formMainUser, setFormMainUser] = React.useState(defaultMainUser);
    const [formFullNameUser, setFormFullNameUser] = useState('');

    // montos y cuotas modal
    const [formErrorInstallments, setFormErrorInstallments] = React.useState({});
    const [formInstallments, setFormInstallments] = React.useState(defaultInstallments);

    // politicas modal
    const [formErrorPoliticies, setFormErrorPoliticies] = React.useState({});
    const [formPoliticies, setFormPoliticies] = React.useState(defaultInstallments); // TODO revisar defaultPoliticies

    const [isTokenValidated, setIsTokenValidated] = useState(false);

    // commercial plans ids
    const [commercialPlans, setCommercialPlans] = useState(null);
    const URL_S3_BUCKET = process.env.REACT_APP_URL_S3_BUCKET;
    //
    // Funcions
    //
    function nextStep (valueStep) {
        // TODO analizar estos dos métodos setStep & increase
        if (valueStep) {
            setStep(valueStep);
        }
        else {
            setStep(step + 1);
        }
        increase();
        return true;
    }

    const back = () => {
        decline();
        if (step > 1) return setStep(step - 1);
    };

    const next = () => {
        if (step < maxSteps) {
            increase();
            setStep(step + 1);
        }
    };

    const parceActivities = (activitiesList) => {
        if (!activitiesList.length) return;

        for (const activity of activitiesList) {
            activities.push({
                id: activity.id,
                label: activity.description.replaceAll('_', ' '),
                value: activity.id
            });
        }
        activities.sort((activityA, activityB) => sortAlphabetically(activityA.label, activityB.label));
    };

    //
    // Handlers
    //
    const closeSteps = () => {
        // remove header extra to clear unique trace id
        setStorage('headerExtra', JSON.stringify({}));
        // currently maxSteps is digitalSignStep
        if (step === maxSteps) {
            return acceptAndCloseModal();
        }
        return closeModal();
    };

    const closeModal = () => {
        // TODO resetear todos los datos
        setFormCheckUser(defaultCheckUser);
        setFormMainUser(defaultMainUser);
        setFormInstallments(defaultInstallments);

        setPercent(0);
        setStep(1);
        setCopy({
            value: '',
            copied: false,
        });
        // Clear all messages
        toaster.clear();
        onHide();
    };

    const acceptAndCloseModal = () => {
        closeModal();
    };

    //
    // progress bar
    //
    const [percent, setPercent] = React.useState(0);

    const decline = () => {
        const value = Math.max(percent - 25, 0);
        setPercent(value);
    };

    const increase = () => {
        const value = Math.min(percent + 25, 100);
        setPercent(value);
    };
    const customStep = (_step, _percent) => {
        if (isInteger(_step) && isInteger(_percent)) {
            setStep(_step);
            setPercent(_percent);
        }
    };
    const status = percent === 100 ? 'success' : null;

    const color = useMemo(() => {
        if (percent === 100) return '#52c41a';
        return theme.colorAccent;
    }, [percent, theme]);

    //
    // Report error by email
    //
    // eslint-disable-next-line react/no-multi-comp
    const submitToast = (error) => {
        const dataError = getDataError(error);

        // Delete trace extra data for cloudwatch
        // const traceId = dataError?.extra?.trace || dataError?.trace || '';
        dataError.extra && (delete dataError.extra.trace);

        const message = JSON.stringify(dataError) || '';
        const date = new Date().toLocaleDateString();
        const dateTime = new Date().toLocaleTimeString();

        const data = {
            date,
            dateTime,
            store: store?.name || '',
            fullname: sessionUser?.formattedName || '',
            errorCode: dataError?.extra?.code || dataError?.task?.result?.code || dataError?.code,
            errorMessage: message?.replaceAll('&', '')?.replaceAll('?', '').replaceAll('=', ''),
            documentClient: formCheckUser?.document || '',
            fullnameClient: formCheckUser?.firstName ? `${formCheckUser?.firstName}, ${formCheckUser?.lastName}` : '',
            idOfferExternal: offer?.task?.result?.id_external || '',
            idRequestExternal: request?.id_external || '',
            idRequest: request?.id || '',
            idSignRequest: sign?.id || '',
            traceId: uniqueTraceId?.toString(),
            creditNumber: request?.metadata?.response?.NumeroCredito || '',
        };

        // Delete trace extra data for cloudwatch
        if (data.traceId?.indexOf(',') > 0) {
            data.traceId = data?.traceId?.split(',')?.slice(-1)[0];
        }

        const dataPrepared = getTemplate(data);
        // Solo descarga automática en testing y develop
        downloandReportTest(dataError, error?.msg);

        return (<a href={dataPrepared} style={{ textDecoration: 'underline' }}>Reportar por mail</a>);
    };

    //
    // Test report
    //
    const downloandReportTest = (dataError = undefined, msg = undefined) => {
        // if it is not available, don´t do it
        if (ENABLE?.enableDownloandReportError) {
            const report = `Reportado por: [Digiloans]
Usuario: [${sessionUser?.key}][${sessionUser?.id}]
comercio: [${store?.name}][${store?.id}]
Producto: [FrontEnd%20de%20Originación]
TraceId: [${uniqueTraceId?.toString()}]
Código HTTP: [${dataError?.extra?.code || dataError?.code || ''}]
Mensaje de Error: [${(JSON.stringify(dataError) || '')?.replaceAll('&', '')?.replaceAll('?', '').replaceAll('=', '')}]
MensajeFrontJSON: [${JSON.stringify(msg) || ''}]

Step 1 Verificar usuario 
DNI Cliente: [${formCheckUser?.document || ''}]
Genero Cliente: [${formCheckUser?.gender || ''}]
Nombre Cliente: [${formCheckUser?.firstName ? `${formCheckUser?.firstName}, ${formCheckUser?.lastName}` : ''}]

Step 3 politicas
Politicas: [${formPoliticies?.trade}]

Step 4 montos y cuotas
Id Solicitud Pendiente: [${offer?.id_external || ''}]
Disponible: [${amountLimit?.amountMaxByPerson || ''}]
Monto solicitado: [${formInstallments?.amount}]
Cantidad de cuotas: [${formInstallments?.installments}]

Step 5 formulario
Numero de telefono: [${formMainUser?.validateTelephone ? formMainUser?.telephone : ''}]
PIN ingresado: [${formMainUser?.validateTelephone || ''}]
Id Solicitud externa: [${request?.id_external || ''}]
Id de crédito: [${request?.metadata?.response?.NumeroCredito || ''}]
Id Préstamo: [${request?.id || ''}]

Step 6 link de firma
Id operación de firma: [${sign?.id || ''}]
Hash de firma: [${sign?.hash || ''}]
        `;
            const dateName = `${new Date().getFullYear()}${(new Date().getMonth() + 1)?.toString()?.padStart(2, '0')}${new Date().getDate()}`;
            const dateTimeName = (new Date().toLocaleTimeString())?.replaceAll(':', '').padStart(6, '0');
            updateFile(`cuota-ya-testing-${dateName}-${dateTimeName}.txt`, report?.replaceAll(' ', '%20'));
        }
    };

    function populateUser (person) {
        const idDepartment = getDepartmentByLocation(person?.domicilio?.idLocality);

        setFormMainUser((oldPerson) => ({
            id: person.id,
            firstName: person.firstName,
            lastName: person.lastName,
            document: person.document,
            gender: person.gender,
            bornDate: parseDate(person?.bornDate) || oldPerson?.bornDate,
            email: person.email || '',
            telephone: person.telephone,
            cellPhoneAreaCode: `${person.domicilio.cellPhoneAreaCode * 1}`,
            cellPhoneCharacteristic: person.domicilio.cellPhoneCharacteristic,
            cellPhoneNumber: person.domicilio.cellPhoneNumber,
            additionalPhoneAreaCode: person.domicilio.additionalPhoneAreaCode || '',
            additionalPhoneCharacteristic: person.domicilio.additionalPhoneCharacteristic || '',
            additionalPhoneNumber: person.domicilio.additionalPhoneNumber || '',
            province: person.domicilio.idProvince,
            department: idDepartment,
            location: person.domicilio.idLocality,
            postcode: person.domicilio.postcode || '',
            street: person.domicilio.street || '',
            number: person.domicilio.number || '',
            floor: person.domicilio.floor || '',
            apartment: person.domicilio.apartment || '',
            activity: person.activity.id,
            amount: person.monthlyAmount,
            'reference-firstName': person.reference.firstName || '',
            'reference-lastName': person.reference.lastName || '',
            'reference-relation': person.reference.Vinculo || '',
            'reference-telephone': person.reference.Telefono,
            'reference-isCellPhone': person.reference.TelefonoCelular,
            'reference-phoneAreaCode': person.reference.TelefonoCodigoArea || '',
            'reference-phoneCharacteristic': person.reference.TelefonoCaracteristica || '',
            'reference-phoneNumber': person.reference.TelefonoNumero || '',
            validateTelephone: '',
        }));

        setFormCheckUser({
            firstName: person.firstName,
            lastName: person.lastName,
            document: person.document,
            gender: person.gender,
            telephone: person.telephone,
            cellPhoneAreaCode: person.domicilio.cellPhoneAreaCode,
            cellPhoneCharacteristic: person.domicilio.cellPhoneCharacteristic,
            cellPhoneNumber: person.domicilio.cellPhoneNumber
        });
    }

    //
    // Properties for all steps
    //
    const context = {
        formRef,
        // Get User
        formCheckUser,
        setFormCheckUser,
        formErrorCheckUser,
        setFormErrorCheckUser,
        repeatUsers,
        setRepeatUsers,
        // Installments
        formInstallments,
        setFormInstallments,
        formErrorInstallments,
        setFormErrorInstallments,
        commercialPlans,
        installmentsExtraData,
        setInstallmentsExtraData,
        // Form User Create/Update
        formMainUser,
        setFormMainUser,
        formErrorMainUser,
        setFormErrorMainUser,
        formFullNameUser,
        setFormFullNameUser,
        // Politicies
        formPoliticies,
        setFormPoliticies,
        formErrorPoliticies,
        setFormErrorPoliticies,
        // SMS
        buttonSmsClicked,
        setButtonSmsClicked,
        // general use
        increase,
        customStep,
        step,
        setStep,
        maxSteps,
        nextStep,
        onHide,
        isLoading,
        setIsLoading,
        activities,
        politicies,
        setPoliticies, // quizas no es necesario que esté acá
        installment,
        setInstallment,
        amountLimit,
        setAmountLimit, // quizas no es necesario
        back,
        next,
        closeModal,
        isAllowContinue,
        setIsAllowContinue,
        isAllowBack,
        setIsAllowBack,
        submitToast,
        copy,
        setCopy,
        acceptAndCloseModal,
        idStore,
        request,
        setRequest,
        offer,
        setOffer,
        uniqueTraceId,
        setUniqueTraceId,
        downloandReportTest,
        setSign,
        sign,
        populateUser,
        notification,
        setNotification,
        isTokenValidated,
        setIsTokenValidated,
    };

    //
    // order of steps
    //
    const views = {
        1: (context) => checkPersonStep(context),
        99: (context) => CreatePersonStep(context),
        100: (context) => RepeatPersonsStep(context),
        2: (context) => tradePoliciesStep(context), // TODO optional if store has one, don't show it. Move to step 2
        3: (context) => installmentsStep(context),
        4: (context) => ModifyPersonStep(context),
        5: (context) => DigitalSignStep(context),
    };

    //
    // useEffect
    //

    useEffect(() => {
        removeStorage('headerExtra');
        const traceId = (new ShortUniqueId({ length: 6 }))();
        setUniqueTraceId(traceId);
        setStorage('headerExtra', JSON.stringify({ UniqueTraceId: traceId }));
        // if activities were populated, finished
        if (activities.length) {
            return;
        }

        cuotitasStoreService
            .getActivities()
            .then(res => {
                parceActivities(res);
                return res;
            })
            .catch(e => {
                console.error('Error: ', e);
                parceActivities(activitiesResponse);
                // Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                return [];
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isTokenValidated) return;
        setIsTokenValidated(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formMainUser.cellPhoneAreaCode, formMainUser.cellPhoneCharacteristic, formMainUser.cellPhoneNumber]);

    useEffect(() => {
        if (ENABLE.enableGetInstallments) {
            const fetchData = async () => {
                try {
                    let data;
                    if (ENABLE.enableGetInstallmentsDatabase) {
                        data = await cuotitasStoreService.getBusinessPlansInstalments();
                    }
                    else {
                        const timestamp = new Date().getTime();
                        const response = await fetch(`${URL_S3_BUCKET}/loans/commercialPlans/PlanComercial.json?timestamp=${timestamp}`);
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        data = await response.json();
                    }
                    setCommercialPlans(data);
                }
                catch (error) {
                    console.error('Error fetching the data:', error);
                }
            };

            fetchData();
        }
    }, []);

    const View = useMemo(() => views[step], [step]);

    //
    // Main component
    //
    return (
        <Modal
            open={show}
            onClose={closeSteps}
            backdrop={'static'}
            className={`${show ? 'show in' : ''}`}
        >
            <Modal.Header>
                <Modal.Title>
                    {!isLoading && (<span>Nuevo Préstamo</span>)}
                    {isLoading && (step === 1 ? <Loader size="md" content="Verificando..." /> : <Loader size="md" content="Creando Solicitud..." />)}
                </Modal.Title>
            </Modal.Header>
            {
                <div>
                    <Progress.Line percent={percent} id={percent === 100 ? 'progress-bar-full' : 'progress-bar'} strokeColor={color} status={status} />
                </div>
            }
            {/* Paragraph like a loader */}
            {/* {isLoading && (
                <Modal.Body className='mb-5 h-100 py-1' style={{ height: '540px' }}>
                    <div className='row m-0' style={body0} >
                        <Paragraph style={{ marginTop: 30 }} rows={7} active />
                    </div>
                </Modal.Body>
            )} */}
            {/* BODY & FOOTER OF MODAL */}
            {!isLoading && (<View {...context} />)}
        </Modal>
    );
};
